import styled from 'styled-components';
import { ONE_LINE_HEIGHT } from './Description.constants';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 15px;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 30px 0;
    border-radius: 0;
  }
`;

export const DescriptionTextBox = styled.div<{ $isOpen?: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
  overflow: hidden;
`;

export const DescriptionText = styled(Typography.Body)<{
  $linesCount: number;
}>`
  display: -webkit-box;
  max-height: ${({ $linesCount }) => ONE_LINE_HEIGHT * $linesCount}px;
  white-space: pre-line;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ $linesCount }) => $linesCount};
  overflow: hidden;
`;

export const DescriptionToggle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  max-width: max-content;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.palette.system.deepBlue};
    }
  }
`;
